import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  login_status: 0,//登录状态
  acs_Token: '',
  active_status: '1',//保留菜单激活状态
  got_weather: false,
  isNetwork: true,
  login_User: '',
  user_info: {},
  sysIdInfo: '3',
  platformName: '',
  alarm_Info:{},
};
const mutations = {
  changeMenu: (state, payload) => {
    state.active_status = payload;
  },
  activateToken: (state, payload) => {
    state.Login_status = payload.status;
    state.acs_Token = payload.acs_token;
    state.login_User = payload.loginedUser || localStorage.getItem('username');
  },
  gotWeather: (state, payload) => {
    state.got_weather = payload;
  },
  changeNetwork: (state, payload) => {
    state.isNetwork = payload
  },
  getSysId: (state, payload) => {
    state.sysIdInfo = payload;
  },
  getuserInfo: (state,payload) => {
    state.user_info = payload;
  },
  getalarmInfo: (sate,payload) => {
    sate.alarm_Info = payload;
  }
};
export default new Vuex.Store({
  state,
  mutations,
  actions: {//移步操作mutation里的方法

  }
})
